define('lib/backbone/Backbone.PodioPaginatedCollection',['require','underscore','lib/backbone/Backbone.PodioCollection'],function(require) {

  var _ = require('underscore');
  var CollectionPodioBase = require('lib/backbone/Backbone.PodioCollection');

  // Podio Pagination Collection. Use via inheritance.
  // Call initPagination() from your init function.

  return CollectionPodioBase.extend({

    initPagination: function(currentPage, itemsPerPage) {
      this.itemsPerPage = itemsPerPage || 10;
      this.currentPage = currentPage || 1;
      _.bindAll(this, 'fetch', 'parse');
    },

    fetch: function(options, paginationOptions) {
      var offset;
      if (paginationOptions && paginationOptions.page) {
        if (paginationOptions.page < 1 || (this.pagesAmount > 0 && paginationOptions.page > this.pagesAmount)) {
          this.trigger('errorPageNumber');
          return false;
        }
        offset = (this.currentPage - 1) * this.itemsPerPage;

        options = options || {};
        options.data = options.data || {};
        _.extend(options.data, {
          offset: offset,
          limit: this.itemsPerPage
        });
      }

      // Call super method
      this._super(options);

    },

    parse: function(response) {
      if (response.status == 'ok' && response.data.object) {
        this.count = response.data.meta.count;
        this.totalCount = response.data.meta.total_count;
        this.pagesAmount = Math.ceil(this.count / this.itemsPerPage);
        return response.data.object;
      }
    },

    getPage: function(page, options) {
      this.currentPage = page;
      this.fetch(options, { 'page': page });
    },

    nextPage: function() {
      if (this.isLastPage()) {
        return false;
      }
      this.fetch({ 'page': this.currentPage++ });
    },

    prevPage: function() {
      if (this.isFirstPage()) {
        return false;
      }
      this.fetch({ 'page': this.currentPage-- });
    },

    isLastPage: function() {
      return this.currentPage === this.pagesAmount;
    },

    isFirstPage: function() {
      return this.currentPage === 1;
    }

  });

});

